import { Icon, IconID } from '@common/Icon/Icon';
import { WidenImage } from '@common/Widen/WidenImage';
import type { Teasers } from '@generated/graphql';
import { getLocale } from '@libs/constants';
import { WidenUtil } from '@libs/widen-utils';
import classNames from 'classnames';
import Image from 'next/image';
import { useRouter } from 'next/router';
import styles from './MarketingTeaserBox.module.scss';
import { IGUS_REWRITE } from '@libs/redirect.helper';

export interface MarketingTeaserProps {
  teaser: Teasers;
}

export const MarketingTeaserBox = ({ teaser }: MarketingTeaserProps) => {
  const router = useRouter();
  const locale = getLocale(router);

  const isWidenImage = teaser?.widen_url ? WidenUtil.isWidenImageUrl(teaser.widen_url) : false;
  const widenShortCode = teaser?.widen_url ? WidenUtil.extractWidenImageId(teaser.widen_url) : undefined;

  return (
    <a
      href={IGUS_REWRITE(teaser.link ?? ':w-0', locale)}
      className={classNames(styles.box, 'bg-gray-50 relative flex')}
    >
      <div className="flex-col pr-4 relative leading-7 max-w-full w-full pb-4 text-sm">
        <div className="float-left mr-4 inline-block">
          {isWidenImage && widenShortCode && (
            <WidenImage
              height={150}
              width={150}
              shortCode={widenShortCode}
              filename="teaser_image"
              quality={100}
              layout="fixed"
            />
          )}
          {!isWidenImage && teaser.image && (
            <Image
              unoptimized
              width={150}
              height={150}
              src={teaser.widen_url ?? ''}
              alt={teaser?.label?.toString() ?? ''}
              style={{
                objectFit: 'contain',
              }}
            />
          )}
        </div>
        <div className="mt-4 mb-2 ml-4 leading-8 font-bold">{teaser.label}</div>
        {teaser.text && <div dangerouslySetInnerHTML={{ __html: teaser.text }} className="mt-3 ml-4 leading-10 " />}
        <div className="float-right clear-right relative h-11" />
        <div className="absolute right-4 bottom-4">
          <Icon primary={false} id={IconID.THREE_ARROWS} size={6} />
        </div>
      </div>
    </a>
  );
};
